export const SET_LOGOUT = 'SET_LOGOUT'
export const SET_LOGIN = 'SET_LOGIN'
export const SET_REFRESH = 'SET_REFRESH'
export const SET_ITEM_SELECTED = 'SET_ITEM_SELECTED'
export const SET_LOAD_INIT_DATA = 'SET_LOAD_INIT_DATA'
export const SET_LOADING = 'SET_LOADING'
